import { render, staticRenderFns } from "./grade_demo.vue?vue&type=template&id=04160634"
import script from "./grade_demo.vue?vue&type=script&lang=js"
export * from "./grade_demo.vue?vue&type=script&lang=js"
import style0 from "./grade_demo.vue?vue&type=style&index=0&id=04160634&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports